import Image from 'components/image'
import { mobileAppDownloadPath } from 'lib/urls'
import { track } from 'lib/analytics'
import InfoButton from '../../../../../../home/RebrandedHome/shared/Buttons/InfoButton/InfoButton'
import css from './AddExperiencePrimer.styles.scss'
import { useNavigate } from 'react-router-dom-v5-compat'

interface AddExperiencePrimerProps {
  nextPath: string
}

const trackingAttributes = {
  eventLocation: track.EventLocation.ONBOARDING_MINUS_ADD_WALKTHROUGH_INTRO,
}

export const AddExperiencePrimer = ({ nextPath }: AddExperiencePrimerProps) => {
  const navigate = useNavigate()

  track.appDownloadInterstitialViewed(trackingAttributes)
  const goToNext = () => {
    track.onboardingQuestionAnswered(trackingAttributes)
    navigate(nextPath)
  }
  return (
    <div className={css.AddExperiencePrimerContainer}>
      <Image
        className={css.RainbowImage}
        src="https://images.babylist.com/image/upload/v1697174452/Rainbow_yzrwgp.svg"
        alt="Rainbow Emoticon"
      />
      <h1 className={css.AddExperiencePrimerTitle}>
        Let's give you a taste of all the things you can add on Babylist.
      </h1>
      <h2 className={css.AddExperiencePrimerSubtitle}>
        Spoiler... it's everything!
      </h2>

      <InfoButton
        block
        pill
        className={css.AddButton}
        onClick={() => goToNext()}
      >
        Add My First Item
      </InfoButton>

      <p className={css.AppStoreLink}>
        <a href={mobileAppDownloadPath()}>Ready to add anything in the app?</a>
      </p>
    </div>
  )
}
